import React from 'react';
import { Rocket, Sparkles, TrendingDown, Heart, Clock, Users } from 'lucide-react';

const CadenceImpact = () => {
  const impacts = [
    { icon: Rocket, text: 'Faster skill mastery' },
    { icon: Sparkles, text: 'Higher confidence in live conversations' },
    { icon: TrendingDown, text: 'Reduced escalations' },
    { icon: Heart, text: 'Improved customer and client experience' },
    { icon: Clock, text: 'Less manager coaching time' },
    { icon: Users, text: 'More consistent performance across teams' }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Measured <span className="text-cyan-400">Impact</span>
          </h2>
          <p className="text-lg text-gray-400">
            Organizations using AI-driven role-play experience:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {impacts.map((impact, index) => {
            const Icon = impact.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-5 bg-gradient-to-br from-green-500/5 to-cyan-500/5 border border-green-500/20 rounded-xl hover:border-green-500/40 transition-all duration-300"
              >
                <Icon className="w-6 h-6 text-green-400 flex-shrink-0" />
                <p className="text-gray-300">{impact.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CadenceImpact;
